import { render } from "./PaymentUnsuccessful.vue?vue&type=template&id=98373876"
import script from "./PaymentUnsuccessful.vue?vue&type=script&lang=js"
export * from "./PaymentUnsuccessful.vue?vue&type=script&lang=js"

import "./PaymentUnsuccessful.vue?vue&type=style&index=0&id=98373876&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__